var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9736 15.5C23.1452 15.5 22.4736 16.1716 22.4736 17C22.4736 17.8284 23.1452 18.5 23.9736 18.5V15.5ZM32.921 18.5C33.7494 18.5 34.421 17.8284 34.421 17C34.421 16.1716 33.7494 15.5 32.921 15.5V18.5ZM23.9736 18.5H32.921V15.5H23.9736V18.5Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9736 36.5525C23.1452 36.5525 22.4736 37.2241 22.4736 38.0525C22.4736 38.881 23.1452 39.5525 23.9736 39.5525V36.5525ZM32.921 39.5525C33.7494 39.5525 34.421 38.881 34.421 38.0525C34.421 37.2241 33.7494 36.5525 32.921 36.5525V39.5525ZM23.9736 39.5525H32.921V36.5525H23.9736V39.5525Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9736 8.65796C23.1452 8.65796 22.4736 9.32953 22.4736 10.158C22.4736 10.9864 23.1452 11.658 23.9736 11.658V8.65796ZM44.4999 11.658C45.3284 11.658 45.9999 10.9864 45.9999 10.158C45.9999 9.32953 45.3284 8.65796 44.4999 8.65796V11.658ZM23.9736 11.658H44.4999V8.65796H23.9736V11.658Z",
    fill: "#727272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9736 29.7104C23.1452 29.7104 22.4736 30.382 22.4736 31.2104C22.4736 32.0388 23.1452 32.7104 23.9736 32.7104V29.7104ZM44.4999 32.7104C45.3284 32.7104 45.9999 32.0388 45.9999 31.2104C45.9999 30.382 45.3284 29.7104 44.4999 29.7104V32.7104ZM23.9736 32.7104H44.4999V29.7104H23.9736V32.7104Z",
    fill: "#727272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1316 7H4.5V19.6316H17.1316V7Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1316 28.0525H4.5V40.6841H17.1316V28.0525Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71045 13.5072L10.6754 15.4211L17.1315 9.10522",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGroup);
export default __webpack_public_path__ + "static/media/checkbox-group.dd5a23997178179226d17e0e63aed950.svg";
export { ForwardRef as ReactComponent };